import React from 'react';
import { Link } from 'react-router';
import style from './style.module.less';
import moment from 'moment';
import 'moment/locale/de';
import { map, sortBy, flow, reduce } from 'lodash';

function ListEvent({ events }) {
    const months = flow(
        e =>
            sortBy(e, e => {
                return e.page.data.date;
            }),
        e =>
            reduce(
                e,
                (months, e) => {
                    const month = moment(e.page.data.date).format('MMMM');
                    if (!months[month]) {
                        months[month] = [];
                    }
                    months[month].push(e);
                    return months;
                },
                {}
            )
    )(events);

    return (
        <div>
            {map(months, (events, month) => {
                return (
                    <div key={month}>
                        <h2 className={style.month}>
                            {month}
                        </h2>
                        {map(events, (event, idx) => <Event key={idx} path={event.page.path} {...event.page.data} />)}
                    </div>
                );
            })}
        </div>
    );
}

function Event({ title, title2, subline, date, path }) {
    const d = moment(date);
    const day = d.format('DD dd');
    const time = d.format('HH:mm');

    return (
        <Link to={path} className={style.container}>
            <div className={style.date}>
                <div className={style.day}>{day}</div>&nbsp;
                {time}
            </div>
            <div>
                <h2 className={style.heading}>
                    {title}
                </h2>

                {title2 &&
                    <span className={style.title2}>
                        <br />
                        {title2}
                    </span>}
                {subline}
            </div>
        </Link>
    );
}

export default ListEvent;



// WEBPACK FOOTER //
// ../components/ListEvent/index.js